import React, { ReactNode, useContext } from 'react'
import { Tooltip } from './Tooltip'
import { TooltipContext } from './TooltipContext'

export const TooltipContainer = (): ReactNode => {
  const { tooltipList, removeTooltip } = useContext(TooltipContext)

  return (
    <>
      {tooltipList.map((tooltip) => {
        const { id = '', onClose = () => {}, ...otherProps } = tooltip

        return (
          <Tooltip
            {...otherProps}
            key={id}
            id={id}
            onClose={(e) => {
              removeTooltip(id)
              onClose(e)
            }}
          />
        )
      })}
    </>
  )
}
